<template>
  <div>
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        信用账户充值
      </h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="搜索标题/流水号/交易编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click.native="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="osg.has('PartnerCreditRechargeForm,new')"
          type="primary"
          @click.native="doNew"
          class="c-m-l-10"
        >
          账户充值
        </el-button>
        <el-button
          v-if="osg.has('PartnerCreditRechargeForm,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:code|string#or': searchValue,
                'fpi-regex:transactionNO|string#or': searchValue,
                'in:state|array-integer#and': '0,1',
                beanName: 'partnerCreditRechargeForm',
                title: '信用账户充值'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" :data="fpi.data" empty-text="暂无数据" height="calc(100% - 50px)">
          <c-table :fields="extFields"></c-table>
          <el-table-column
            fixed="right"
            width="100px"
            v-if="
              osg.has('PartnerCreditRechargeForm,audit') ||
                osg.has('PartnerCreditRechargeForm,remove')
            "
          >
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="
                      scope.row.state == 1 &&
                        scope.row.status == 0 &&
                        osg.has('PartnerCreditRechargeForm,audit')
                    "
                    @click.native="auditClick(scope.row, 1)"
                  >
                    审核通过
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="
                      scope.row.state == 1 &&
                        scope.row.status == 0 &&
                        osg.has('PartnerCreditRechargeForm,audit')
                    "
                    @click.native="auditClick(scope.row, -1)"
                  >
                    审核不通过
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1 && osg.has('PartnerCreditRechargeForm,remove')"
                    @click.native="doRemove(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="信用账户充值" :visible.sync="openDetail">
      <el-form labelWidth="150px" label-position="left">
        <el-form-item label="修链对公账户" label-position="left">
          <el-input value="110943084710501" disabled>
            <div slot="append" @click="osg.doCopy('110943084710501')" class="c-pointer">
              复制
            </div>
          </el-input>
        </el-form-item>
        <el-form-item label="开户行" label-position="left">
          <el-input value="招商银行股份有限公司北京建外大街支行" disabled>
            <div
              slot="append"
              @click="osg.doCopy('招商银行股份有限公司北京建外大街支行')"
              class="c-pointer"
            >
              复制
            </div>
          </el-input>
        </el-form-item>
        <el-form-item label="公司名称" label-position="left">
          <el-input value="北京修链科技有限公司" disabled>
            <div slot="append" @click="osg.doCopy('北京修链科技有限公司')" class="c-pointer">
              复制
            </div>
          </el-input>
        </el-form-item>
      </el-form>
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="信用账户充值审核" :visible.sync="audit.show">
      <el-form :model="audit.formData" :rules="rules" ref="auditForm" label-width="150px">
        <el-form-item label="标题">
          <el-input v-model="audit.formData.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="流水号">
          <el-input v-model="audit.formData.code" disabled></el-input>
        </el-form-item>
        <el-form-item
          v-if="audit.formData.status == 1"
          label="交易编号"
          prop="transactionNO"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请填写交易编号'
          }"
        >
          <el-input v-model="audit.formData.transactionNO"></el-input>
        </el-form-item>
        <el-form-item
          v-if="audit.formData.status == -1"
          label="审核未通过原因"
          prop="failMemo"
          :rules="{
            required: true,
            trigger: 'change',
            message: '请填写审核未通过原因'
          }"
        >
          <el-input v-model="audit.formData.failMemo" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="auditConfirm">确 定</el-button>
        <el-button @click="auditCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'PartnerCreditRechargeForm',
  data() {
    window.$this = this;
    return {
      name: 'partnerCreditRechargeForm',
      fpi: { data: [] },
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        exts: {}
      },
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      audit: {
        show: false,
        formData: {}
      }
    };
  },
  mounted() {
    this.osg.getFields('partnerCreditRechargeForm', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:transactionNO|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('/basic/rechargeForm/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        exts: {}
      };
    },
    doSave() {
      if (this.osg.validate()) {
        this.formData.voucher =
          this.osg.downloadUrl + this.formData.exts.voucherList[0].response.key;
        this.osg.ajax(
          'basic/rechargeForm/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.osg.toast('保存成功');
            this.doInit();
            this.getData();
          }
        );
      }
    },
    doRemove(id) {
      this.osg.confirm('是否确认禁用，禁用后无法启用？', () => {
        this.osg.ajax('basic/rechargeForm/remove.do', { id }, () => {
          this.osg.toast('已禁用');
          this.getData();
        });
      });
    },
    auditClick(row, status) {
      this.audit.formData.id = row._id;
      this.audit.formData.name = row.name;
      this.audit.formData.code = row.code;
      this.audit.formData.status = status;
      this.audit.show = true;
    },
    auditConfirm() {
      if (this.audit.formData.status == 1) {
        this.approved(this.audit.formData);
      } else {
        this.notApproved(this.audit.formData);
      }
    },
    auditCancel() {
      this.audit = {
        show: false,
        formData: {}
      };
    },
    approved({ id, transactionNO }) {
      if (this.osg.validate('auditForm')) {
        this.osg.ajax('basic/rechargeForm/approved.do', { id, transactionNO }, () => {
          this.osg.toast('审核已通过');
          this.getData();
          this.auditCancel();
        });
      }
    },
    notApproved({ id, failMemo }) {
      if (this.osg.validate('auditForm')) {
        this.osg.ajax('basic/rechargeForm/notApproved.do', { id, failMemo }, () => {
          this.osg.toast('审核未通过');
          this.getData();
          this.auditCancel();
        });
      }
    }
  }
};
</script>
<style lang="scss"></style>
